import axios from 'axios';

const env = typeof process !== 'undefined' && process.env ? process.env : {};
const appUrl = (env.VUE_APP_APP_URL || '').replace(/\/$/, '');

function withCredentials(config = {}) {
  return {
    ...config,
    withCredentials: true,
  };
}

function appPath(path) {
  return `${appUrl}${path}`;
}

function apiPath(path) {
  return appPath(`/api/${path.replace(/^\/+/, '')}`);
}

axios.defaults.withCredentials = true;

const AuthApi = {
  csrf() {
    return axios.get(appPath('/sanctum/csrf-cookie'), withCredentials());
  },

  async login(credentials) {
    await this.csrf();
    return axios.post(apiPath('login'), credentials, withCredentials());
  },

  async register(payload) {
    await this.csrf();
    return axios.post(apiPath('register'), payload, withCredentials());
  },

  async sendResetPasswordEmail(payload) {
    await this.csrf();
    return axios.post(apiPath('reset-password-email'), payload, withCredentials());
  },

  async resetPassword(payload) {
    await this.csrf();
    return axios.post(apiPath('reset-password'), payload, withCredentials());
  },

  postSocialLogin(provider, payload) {
    return axios.post(apiPath(`sociallogin/${provider}`), payload, withCredentials());
  },

  async logout() {
    await this.csrf().catch(() => null);
    return axios.post(apiPath('logout'), {}, withCredentials());
  },

  me() {
    return axios.get(apiPath('me'), withCredentials());
  },
};

export default AuthApi;
